import React, { useState } from 'react'
import _ from 'lodash'
import { ArrowDownUp } from 'react-bootstrap-icons'

import T from 'utils/useLocalizer'
import { buttons } from 'utils/resources'
import { ListHeaderItem } from 'models/commonModel'


interface Props {
    headerItems: ListHeaderItem<any>[]
    truncateWidth?: number
    hasActions?: boolean
    isAllSelected?: boolean
    sortHandler: (sortBy: string) => any,
    selectAllHandler?:(event:any) => void
}

const SortableListHeader = ({ headerItems, truncateWidth = 200, hasActions = false, sortHandler ,selectAllHandler, isAllSelected }: Props) => {

    const resources = {
        sortTooltip: T(buttons.sortTooltip)
    }

    const [order, setOrder] = useState<'asc' | 'desc'>('asc')
    const [orderBy, setOrderBy] = useState<string>('id')

    const onSort = (sortBy: string) => {
        setOrder(orderBy === sortBy ? (order === 'asc' ? 'desc' : 'asc') : 'asc')   // change order direction only if sort id is the same
        setOrderBy(sortBy)

        sortHandler(sortBy)
    }

    return (
        <tr>
            {headerItems.map(headerItem =>
                <th key={headerItem.id as string} scope='col'><div className='fw-bold d-flex align-items-center justify-content-between' style={{ height: 36.7 }}>
                    {headerItem.isCheckbox && selectAllHandler ? <input
                        type='checkbox'
                        id='add-otp-expiration'
                        className='form-check-input cursor-pointer'
                        checked={isAllSelected}
                        onChange={(e) => selectAllHandler(e)}
                    /> : <span className={`truncate-width-${truncateWidth}`} title={headerItem.label}>{headerItem.label}</span>
                    }
                    {headerItem.sortable &&
                        <button type='button' className='btn btn-link' onClick={() => onSort(headerItem.id)} title={resources.sortTooltip}>
                            <ArrowDownUp size={12} />
                        </button>}
                </div></th>
            )}
            {hasActions && <th scope='col'></th>}
        </tr>
    )
}

export default React.memo(SortableListHeader, (prev, next) => _.isEqual(prev, next))